import React from 'react';
import './index.css';

interface Props {
  required?: boolean;
  children: React.ReactNode;
  htmlFor?: string;
}

const Label = (props: Props) => {
  return (
    <label
      id={props.htmlFor && `${props.htmlFor}-label"`}
      htmlFor={props.htmlFor}
      className={`form-label mb-1 px-0 text-graphite ${props.required ? 'fieldRequired' : ''}`}
    >
      {props.children}
    </label>
  )
}

export default Label;
